import React from "react";

interface Props {
  label: string;
  icon: React.ReactNode;
  onOpen: () => void;
  testid: string;
}

export const DesktopIcon = ({ label, icon, onOpen, testid }: Props) => (
  <button
    data-testid={testid}
    onClick={onOpen}
    className="group flex w-16 flex-col items-center gap-1.5 focus:outline-none md:w-20"
  >
    <span className="flex h-10 w-10 items-center justify-center border-2 border-ink bg-white text-ink shadow-hard-sm transition-transform duration-150 group-hover:-translate-y-0.5 group-active:translate-y-0.5 group-focus-visible:outline group-focus-visible:outline-2 group-focus-visible:outline-lnpink md:h-12 md:w-12">
      {icon}
    </span>
    <span className="border border-ink/20 bg-cream px-1 py-0.5 font-spacemono text-[9px] font-bold lowercase tracking-wide group-hover:bg-butter md:px-1.5 md:text-[10px]">
      {label}
    </span>
  </button>
);
